module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-status"
  }, [(_vm.item.valueArrMap) ? _c('el-select', {
    attrs: {
      "filterable": "",
      "disabled": _vm.item.nonEditable,
      "placeholder": _vm.item.placeholder
    },
    model: {
      value: (_vm.form[_vm.item.attr]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.item.attr, $$v)
      },
      expression: "form[item.attr]"
    }
  }, _vm._l((_vm.item.valueArrMap), function(arr) {
    return _c('el-option', {
      key: arr.key,
      attrs: {
        "label": arr.value,
        "value": arr.key
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.form[_vm.item.attr] === '2' && _vm.item.isBelonger) ? [_c('div', {
    staticClass: "manager"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("归属人")]), _vm._v(" "), _c('v-manager', {
    attrs: {
      "item": _vm.belongerItem,
      "form": _vm.form
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "manager"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "disabled": _vm.item.nonEditable,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.payMethod),
      callback: function($$v) {
        _vm.$set(_vm.form, "payMethod", $$v)
      },
      expression: "form.payMethod"
    }
  }, _vm._l((_vm.payMethodArray), function(arr) {
    return _c('el-option', {
      key: arr.key,
      attrs: {
        "label": arr.value,
        "value": arr.key
      }
    })
  }))], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56197614","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/payment/payment-status.vue
// module id = 1277
// module chunks = 82